import { render } from "./CompassWord.vue?vue&type=template&id=4cb0db9c&scoped=true"
import script from "./CompassWord.vue?vue&type=script&lang=js"
export * from "./CompassWord.vue?vue&type=script&lang=js"

import "./CompassWord.vue?vue&type=style&index=0&id=4cb0db9c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/sun-motion-visualization/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb0db9c"]])

export default __exports__